module.exports = __webpack_public_path__ + "static/media/asv_bloc2-min.215d2910.png";